/**
 * Pastille « VEGAN » du magasin (01/11/2026), à la place de l'émoji 🌱.
 *
 * Ce n'est PAS un label : il n'existe aucun logo végan officiel, et les labels
 * privés (V-Label, tournesol de la Vegan Society) sont des marques déposées
 * que seul le fabricant d'un produit contrôlé peut apposer. C'est une mention
 * du magasin — dessinée ici, sans imiter aucun de ces logos — posée seulement
 * sur les produits TRANSFORMÉS (une carotte ou un sac de riz sont végans par
 * nature, la pastille n'y apprendrait rien au client).
 */

interface PastilleVeganProps {
  /** `vignette` : coin de la photo du catalogue ; `fiche` : en-tête de la fiche. */
  taille?: 'vignette' | 'fiche';
}

function Feuille({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 16 16" className={className} aria-hidden="true">
      <path
        d="M13.6 2.4C8.4 2 3.3 4.2 3 9.4c-.1 1.5.4 2.8 1.1 3.7.6-2.9 2.4-5.4 5.2-7-2.2 1.9-3.7 4.4-4.2 7.4 1 .5 2.3.6 3.6.2 4.4-1.4 5.5-6.6 4.9-11.3Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function PastilleVegan({ taille = 'vignette' }: PastilleVeganProps) {
  if (taille === 'fiche') {
    return (
      <span className="inline-flex items-center gap-2 px-4 py-2 text-lg font-bold tracking-wide bg-[#4a5c3a] text-white rounded-full">
        <Feuille className="w-5 h-5 text-[#cfe3b0]" />
        VEGAN
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center gap-1 pl-1.5 pr-2 py-0.5 text-[10px] font-extrabold tracking-[0.08em] bg-[#4a5c3a] text-white rounded-full shadow-sm ring-1 ring-white/70"
      title="Vegan : aucun ingrédient d'origine animale"
    >
      <Feuille className="w-3 h-3 text-[#cfe3b0]" />
      VEGAN
    </span>
  );
}
